import axios from 'axios';
import Resource from './Resource'
import Comment from './Comment'
import Reply from './Reply'

export default class Article extends Resource {
  static ENDPOINT = '/api/article'

  constructor (args) {
    super()
    this.extend(args)
  }

  static async list (query) {
    const { data } = await axios.get(`${this.ENDPOINT}`, { params: query });
    return data
  }

  static async get (obj) {
    let res
    if (typeof obj === 'string') {
      res = await axios.get(`${this.ENDPOINT}/${obj}`);
    } else {
      res = await axios.get(`${this.ENDPOINT}/getbyquery`, { params: obj });
    }
    if (res.data) {
      res.data.comments = res.data.comments.map(c => {
        c.replies = c.replies.map(r => new Reply(r))
        return new Comment(c)
      })
    }
    return res.data && new this(res.data);
  }

  async save (payload) {
    let res = null;
    if (this._id) { // 수정
      this.updateDate = new Date()
      res = await axios.put(`${Article.ENDPOINT}/${this._id}`, payload, { headers: { 'Content-Type': 'multipart/form-data' } });
    } else { // 생성
      res = await axios.post(Article.ENDPOINT, payload, { headers: { 'Content-Type': 'multipart/form-data' } });
    }
    return res.data && new Article(res.data);
  }

  static create (category, writer) {
    const article = {
      category,
      writer: {
        _id: writer._id,
        name: writer.name
      }
    }
    return new Article(article)
  }
}
